var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-footer"},[_c('img',{staticClass:"logo3",staticStyle:{"height":"20px","width":"auto"},attrs:{"src":_vm.localizeAsset('logo3.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }